import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asalab',
  templateUrl: './asalab.component.html',
  styleUrls: ['./asalab.component.scss']
})
export class AsalabComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
